import ModusServiceCollection from "../ModusServiceCollection";
import ResultEventSampleModel from "../../models/modus/ResultEventSampleModel";
import LaboratoryTestPackageCollection from "./LaboratoryTestPackageCollection";

/**
 * ResuptEventSample collection
 */
export default class ResultEventSampleCollection extends ModusServiceCollection {

  // Model that is contained in this collection.
  model() {
    return ResultEventSampleModel;
  }

  getLaboratoryTestPackages() {
    let collection = new LaboratoryTestPackageCollection();
    if (this.length) {
      this.each((sample) => {
        let test_package = sample.getLaboratoryTestPackage();
        if(test_package && test_package.id) {
          collection.add(test_package);
        }
      });
    }
    return collection;
  }

}
